/* global Wix, window */
import PropTypes from 'prop-types';
import React from 'react';
import Chat from '../Chat/Chat';
import {connect} from 'react-redux';
import {expandChat, collapseChat, technicalError, updateDesign, updateLayout, updateTexts} from '../../actions';
import {DEFAULT_CHAT_SETTINGS} from 'inbox-common/dist/default-chat-settings';
import globals from '../../services/globals';
import History from '../../services/history';
import wix from '../../utils/wix';
import {withExperiments} from 'wix-experiments-react';
import pick from 'lodash/pick';
import {EDITOR_VIEW_MODE} from '../../constants/editor-view-mode';

class ChatMobileWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      instanceId: '',
      userSessionToken: ''
    };
  }

  onTextsChange = texts => {
    this.props.dispatch(updateTexts(texts));
  };

  onLayoutChange = layout => {
    this.props.dispatch(updateLayout(layout));
  };

  onDesignChange = design => {
    this.props.dispatch(updateDesign(design));
  };

  onPublicDataChanged = ({design, layout, texts}) => {
    if (design) {
      this.onDesignChange(design);
    }
    if (layout) {
      this.onLayoutChange(layout);
    }
    if (texts) {
      this.onTextsChange(texts);
    }
  };

  setDefaultSettings = setting => () => {
    return this.onPublicDataChanged(pick(DEFAULT_CHAT_SETTINGS, setting));
  };

  loadChatSettings = () => ['texts', 'layout', 'design']
    .forEach(setting => Wix.Data.Public.get(setting, {scope: 'APP'},
      this.onPublicDataChanged, this.setDefaultSettings(setting)));

  componentDidMount() {
    wix.registerQab(() => {
      wix.showMobileComponent();
      this.props.dispatch(expandChat('uou'));
    });

    const {dispatch} = this.props;
    const instanceId = Wix.Utils.getInstanceId();
    const biToken = Wix.Utils.getInstanceValue('biToken');
    globals.instanceId = instanceId;
    globals.biToken = biToken;
    const visitCount = new History(instanceId).visitCount;

    this.loadChatSettings();

    wix.getUserSessionToken()
      .then(userSessionToken => {
        this.setState({instanceId, userSessionToken, visitCount});
      })
      .then(() => {
        if (!wix.isInView(EDITOR_VIEW_MODE.SITE)) {
          Wix.addEventListener('EDIT_MODE_CHANGE', ({editMode}) => editMode === 'editor' ? this.onCollapse() : null);
        }
      })
      .catch(error => {
        dispatch(technicalError(true));
        console.error(error);
      });
  }

  onChatInit(chatService) {
    ['syncPageTitle', 'subscribeForNavigation', 'subscribeForMetadataChange']
      .forEach(f => wix[f](pageName => {
        chatService.goOnlineIfOffline();
        chatService.updatePresence({pageName});
      }));
  }

  onChatVisible() {
    wix.updateQab({visible: true, notifications: 0});
  }

  onAddMessage() {
    const {unreadCount, collapsed} = this.props;
    if (collapsed) {
      wix.updateQab({visible: true, notifications: unreadCount});
    }
  }

  onSessionTokenChange(newSessionToken) {
    return newSessionToken;
  }

  onCollapse(initiator) {
    wix.hideMobileComponent();
    this.props.dispatch(collapseChat(initiator));
    wix.updateQab({visible: true, notifications: 0});
  }

  /* eslint-disable react/jsx-no-bind */
  render() {

    const dummyMode = !wix.isInView(EDITOR_VIEW_MODE.SITE);

    if (this.state.userSessionToken || (dummyMode && this.state.instanceId)) {
      return (
        <Chat
          instanceId={this.state.instanceId}
          sessionToken={this.state.userSessionToken}
          onChatInit={chatService => this.onChatInit(chatService)}
          visitCount={this.state.visitCount}
          onCollapse={initiator => this.onCollapse(initiator)}
          dummyMode={dummyMode}
          isMobile
          onChatVisible={() => this.onChatVisible()}
          onAddMessage={data => this.onAddMessage(data)}
          />);
    } else {
      return null;
    }
  }

  /* eslint-enable react/jsx-no-bind */
}
ChatMobileWrapper.propTypes = {
  collapsed: PropTypes.bool,
  chatVisible: PropTypes.bool,
  dispatch: PropTypes.func,
  chatSettings: PropTypes.object,
  experiments: PropTypes.object,
  unreadCount: PropTypes.number
};

function mapStateToProps(state) {
  return {
    collapsed: state.collapsed,
    chatVisible: state.chatVisible,
    chatSettings: state.chatSettings,
    unreadCount: state.unreadCount
  };
}

export default withExperiments(connect(mapStateToProps)(ChatMobileWrapper));



// WEBPACK FOOTER //
// ./chat-app/components/ChatMobileWrapper/ChatMobileWrapper.js